import(/* webpackMode: "eager" */ "/home/h/src/auriga-2/clients/web/src/app/page.tsx");
